import { createMemo, Show, splitProps } from "solid-js";
import type { MainProps } from "./_model";
import { createFormControl } from "solid-forms";
import type { FormControlData, FormControlValue } from "../SHARED/_model";

export default function TextArea<V extends FormControlValue, D extends FormControlData>(props: MainProps<V, D>) {
  const [local, others] = splitProps(props, ["control", "hideCharCount"]);
  const _control = Array.isArray(local.control) ? createFormControl<V, D>(...local.control) : local.control;
  const max_length = others.maxLength ?? others.maxlength;
  const char_limit =
    max_length == undefined ? undefined : typeof max_length === "string" ? parseInt(max_length) : max_length;
  const $chars = createMemo(() => {
    if (char_limit == undefined || Number.isNaN(char_limit)) {
      return undefined;
    }
    const text = _control.value as string;
    const chars = text?.length ?? 0;
    return {
      chars,
      limit: char_limit,
      limit_reached: chars >= char_limit,
    };
  });

  return (
    <section
      class={"" + " " + (others.class ?? "")}
      classList={{
        invalid: !!_control.errors,
        touched: _control.isTouched,
        disabled: _control.isDisabled,
        // required: control.isRequired,
      }}
    >
      <textarea
        {...others}
        class={"input"}
        value={_control.value as any}
        oninput={(e) => {
          _control.setValue(e.currentTarget.value as V);
        }}
        onblur={() => _control.markTouched(true)}
        onfocus={() => _control.markTouched(true)}
        onfocusin={() => _control.markTouched(true)}
        onfocusout={() => _control.markTouched(false)}
        disabled={_control.isDisabled}
        required={_control.isRequired}
      />
      <Show when={$chars() != undefined && local.hideCharCount == undefined}>
        <p
          //
          class="char-count"
          classList={{
            "limit-reached": $chars().limit_reached,
          }}
        >
          {$chars().chars}/{$chars().limit}
        </p>
      </Show>
    </section>
  );
}
